module.exports = __webpack_public_path__ + "static/Groups_app_screen-9557157fe1f9c9e23a2dc4a3707c596a.png";